/* eslint-disable */
/*
 * @Author: chengyu
 * @Date: 2022-09-26 16:18:34
 * @Description:
 * 来源于 `npm install json-keys-sort`
 */
// ----- PRIVATE -----
/**
 * Used to check if data type is json or not
 * @param data
 * @return {string}
 */
var typeOf = function (data) {
    var objectConstructor = {}.constructor;
    var arrayConstructor = [].constructor;
    var stringConstructor = 'test'.constructor;
    if (data && data.constructor === objectConstructor) {
        return 'OBJECT';
    }
    else if (data && data.constructor === arrayConstructor) {
        return 'ARRAY';
    }
    else if (data && data.constructor === stringConstructor) {
        return 'STRING';
    }
    else {
        return '';
    }
};
// ------ EXPORT -----
/**
 * json sorting based on keys
 * > considering data is a json object only (not array or anything else)
 * @param data - json to be sorted
 * @param sort - asc (true) / desc (false)
 * @return {{}} - a sorted json object
 */
export function jsonSort(data, sort) {
    if (sort === void 0) { sort = true; }
    if (typeOf(data) === 'ARRAY') {
        var newData = [];
        for (var w = 0; w < data.length; w++) {
            var d = data[w];
            if (typeOf(d) === 'OBJECT' || typeOf(d) === 'ARRAY')
                newData.push(jsonSort(d, sort));
            else {
                newData.push(d);
            }
        }
        return newData;
    }
    else if (typeOf(data) === 'OBJECT') {
        var newKeys = [], newData = {};
        var keys = Object.keys(data).sort();
        if (!sort) {
            for (var i = keys.length - 1; i >= 0; i--)
                newKeys.push(keys[i]);
            keys = newKeys;
        }
        for (var j = 0; j < keys.length; j++) {
            var key = keys[j];
            if (typeOf(data[key]) === 'OBJECT') {
                newData[key] = jsonSort(data[key], sort);
            }
            else if (typeOf(data[key]) === 'ARRAY') {
                newData[key] = [];
                for (var k = 0; k < data[key].length; k++) {
                    var d = data[key][k];
                    if (typeOf(d) === 'OBJECT' || typeOf(d) === 'ARRAY')
                        newData[key].push(jsonSort(data[key][k], sort));
                    else
                        newData[key].push(data[key][k]);
                }
            }
            else
                newData[key] = data[key];
        }
        return newData;
    }
    else
        throw new Error('must be an object/array');
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoianNvbktleXNTb3J0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvcmUvdXRpbHMvanNvbktleXNTb3J0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLG9CQUFvQjtBQUNwQjs7Ozs7R0FLRztBQUVILHNCQUFzQjtBQUV0Qjs7OztHQUlHO0FBQ0gsSUFBTSxNQUFNLEdBQUcsVUFBVSxJQUEwQjtJQUNqRCxJQUFNLGlCQUFpQixHQUFHLEVBQUUsQ0FBQyxXQUFXLENBQUM7SUFDekMsSUFBTSxnQkFBZ0IsR0FBRyxFQUFFLENBQUMsV0FBVyxDQUFDO0lBQ3hDLElBQU0saUJBQWlCLEdBQUcsTUFBTSxDQUFDLFdBQVcsQ0FBQztJQUM3QyxJQUFJLElBQUksSUFBSSxJQUFJLENBQUMsV0FBVyxLQUFLLGlCQUFpQixFQUFFO1FBQ2xELE9BQU8sUUFBUSxDQUFDO0tBQ2pCO1NBQU0sSUFBSSxJQUFJLElBQUksSUFBSSxDQUFDLFdBQVcsS0FBSyxnQkFBZ0IsRUFBRTtRQUN4RCxPQUFPLE9BQU8sQ0FBQztLQUNoQjtTQUFNLElBQUksSUFBSSxJQUFJLElBQUksQ0FBQyxXQUFXLEtBQUssaUJBQWlCLEVBQUU7UUFDekQsT0FBTyxRQUFRLENBQUM7S0FDakI7U0FBTTtRQUNMLE9BQU8sRUFBRSxDQUFDO0tBQ1g7QUFDSCxDQUFDLENBQUM7QUFFRixzQkFBc0I7QUFFdEI7Ozs7OztHQU1HO0FBQ0gsTUFBTSxVQUFVLFFBQVEsQ0FBQyxJQUF5QixFQUFFLElBQVc7SUFBWCxxQkFBQSxFQUFBLFdBQVc7SUFDN0QsSUFBSSxNQUFNLENBQUMsSUFBSSxDQUFDLEtBQUssT0FBTyxFQUFFO1FBQzVCLElBQU0sT0FBTyxHQUEwQixFQUFFLENBQUM7UUFFMUMsS0FBSyxJQUFJLENBQUMsR0FBRyxDQUFDLEVBQUUsQ0FBQyxHQUFHLElBQUksQ0FBQyxNQUFNLEVBQUUsQ0FBQyxFQUFFLEVBQUU7WUFDcEMsSUFBSSxDQUFDLEdBQUcsSUFBSSxDQUFDLENBQUMsQ0FBQyxDQUFDO1lBQ2hCLElBQUksTUFBTSxDQUFDLENBQUMsQ0FBQyxLQUFLLFFBQVEsSUFBSSxNQUFNLENBQUMsQ0FBQyxDQUFDLEtBQUssT0FBTztnQkFDakQsT0FBTyxDQUFDLElBQUksQ0FBQyxRQUFRLENBQUMsQ0FBQyxFQUFFLElBQUksQ0FBQyxDQUFDLENBQUM7aUJBQzdCO2dCQUNILE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUM7YUFDakI7U0FDRjtRQUVELE9BQU8sT0FBTyxDQUFDO0tBQ2hCO1NBQU0sSUFBSSxNQUFNLENBQUMsSUFBSSxDQUFDLEtBQUssUUFBUSxFQUFFO1FBQ3BDLElBQU0sT0FBTyxHQUFHLEVBQUUsRUFDaEIsT0FBTyxHQUF3QixFQUFFLENBQUM7UUFFcEMsSUFBSSxJQUFJLEdBQUcsTUFBTSxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FBQyxJQUFJLEVBQUUsQ0FBQztRQUVwQyxJQUFJLENBQUMsSUFBSSxFQUFFO1lBQ1QsS0FBSyxJQUFJLENBQUMsR0FBRyxJQUFJLENBQUMsTUFBTSxHQUFHLENBQUMsRUFBRSxDQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsRUFBRTtnQkFBRSxPQUFPLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDO1lBQ2pFLElBQUksR0FBRyxPQUFPLENBQUM7U0FDaEI7UUFFRCxLQUFLLElBQUksQ0FBQyxHQUFHLENBQUMsRUFBRSxDQUFDLEdBQUcsSUFBSSxDQUFDLE1BQU0sRUFBRSxDQUFDLEVBQUUsRUFBRTtZQUNwQyxJQUFNLEdBQUcsR0FBRyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUM7WUFFcEIsSUFBSSxNQUFNLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFDLEtBQUssUUFBUSxFQUFFO2dCQUNsQyxPQUFPLENBQUMsR0FBRyxDQUFDLEdBQUcsUUFBUSxDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsRUFBRSxJQUFJLENBQUMsQ0FBQzthQUMxQztpQkFBTSxJQUFJLE1BQU0sQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUMsS0FBSyxPQUFPLEVBQUU7Z0JBQ3hDLE9BQU8sQ0FBQyxHQUFHLENBQUMsR0FBRyxFQUFFLENBQUM7Z0JBQ2xCLEtBQUssSUFBSSxDQUFDLEdBQUcsQ0FBQyxFQUFFLENBQUMsR0FBRyxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUMsTUFBTSxFQUFFLENBQUMsRUFBRSxFQUFFO29CQUN6QyxJQUFNLENBQUMsR0FBRyxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUM7b0JBQ3ZCLElBQUksTUFBTSxDQUFDLENBQUMsQ0FBQyxLQUFLLFFBQVEsSUFBSSxNQUFNLENBQUMsQ0FBQyxDQUFDLEtBQUssT0FBTzt3QkFDakQsT0FBTyxDQUFDLEdBQUcsQ0FBQyxDQUFDLElBQUksQ0FBQyxRQUFRLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUMsQ0FBQyxFQUFFLElBQUksQ0FBQyxDQUFDLENBQUM7O3dCQUM3QyxPQUFPLENBQUMsR0FBRyxDQUFDLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDO2lCQUN0QzthQUNGOztnQkFBTSxPQUFPLENBQUMsR0FBRyxDQUFDLEdBQUcsSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFDO1NBQ2pDO1FBRUQsT0FBTyxPQUFPLENBQUM7S0FDaEI7O1FBQU0sTUFBTSxJQUFJLEtBQUssQ0FBQyx5QkFBeUIsQ0FBQyxDQUFDO0FBQ3BELENBQUMifQ==